import { render } from "./SendMailSuccessModal.vue?vue&type=template&id=4f56ba13"
import script from "./SendMailSuccessModal.vue?vue&type=script&lang=js"
export * from "./SendMailSuccessModal.vue?vue&type=script&lang=js"
script.render = render

export default script